export const topMenu = [
  {
    label: 'Dashboard',
    path: '/dashboard',
    icon: 'rows',
    dataCy: 'dashboard',
    live: true,
  },
  {
    label: 'Projects',
    path: '/projects',
    icon: 'version',
    dataCy: 'projects',
    live: true,
  },
  {
    label: 'API Keys',
    path: '/api-keys',
    icon: 'dots',
    dataCy: 'api-keys',
    live: true,
  },
  {
    label: 'AirDrop',
    path: '/airdrops',
    icon: 'paper-plane',
    dataCy: 'airdrop',
    live: true,
  },
  {
    label: 'Notifications',
    path: '/notifications',
    icon: 'bell',
    dataCy: 'notifications',
    live: true,
  },
  {
    label: 'Wallets',
    path: '/wallets',
    icon: 'card',
    dataCy: 'wallets',
    live: false,
  },
  {
    label: 'Analytics',
    path: '/analytics',
    icon: 'bar-chart',
    dataCy: 'analytics',
    live: false,
  },
]

export const bottomMenu = [
  {
    label: 'NPM',
    url: 'https://www.npmjs.com/package/@zoidpay-tech/zoidcore-web3-toolkit',
    icon: 'npm',
    live: true,
  },
  {
    label: 'Documentation',
    url: 'https://apidocs.zoidcore.com',
    icon: 'question-fill',
    live: true,
  },
  {
    label: 'Academy',
    url: '',
    icon: 'academy',
    live: false,
  },
]

export const socials = [
  {
    url: 'https://www.youtube.com/watch?v=v1nkQsY22sI',
    icon: 'youtube',
  },
  {
    url: 'https://www.linkedin.com/company/zoidpay',
    icon: 'linkedin',
  },
  {
    url: 'https://www.instagram.com/zoidpay/',
    icon: 'instagram',
  },
  {
    url: 'https://twitter.com/ZoidPay',
    icon: 'twitter',
  },
  {
    url: 'https://t.me/zoidpay',
    icon: 'telegram',
  },
  {
    url: 'https://medium.com/zoidcoin-network',
    icon: 'medium',
  },
]
